export default __webpack_public_path__ + "static/media/coaching1.c82185ae.JPG";